import React from "react";

import styled from "styled-components";

import { Wrapper } from "../styles";
import { Image, Link } from "../styles/Design";
import { CustomDivider } from "../styles/Main.styled";

import aboutUsImage from "../../assets/images/about_us.png";

import "./style.css";

const Description = styled.p`
  fosize: 16px;
  line-height: 19.5px;
  margin: 2rem 0;
  width: 30%;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const AboutUs = () => {
  return (
    <Wrapper
      type="container"
      hasColumns
      isSection
      style={{
        alignItems: "center",

      }}
    >
      <Wrapper>
        <h3>
          About us
          <CustomDivider />
        </h3>
        <Description>
          The first Arab and international platform that cares about translators
          around the world and is the first professional platform at the level
          of remote translation
        </Description>
        <Link to="/about-us">Read more</Link>
      </Wrapper>

      <Wrapper>
        <Image fit="cover" src={aboutUsImage} alt="about us" />
      </Wrapper>
    </Wrapper>
  );
};

export default AboutUs;
